export function makeKeyframes(totalSlides: number, animationName = 'scrolling') {
    const pauseDuration = 80;
    const transitionDuration = 20;
    const pausePerSlide = pauseDuration / totalSlides;
    const transitionPerSlide = transitionDuration / totalSlides;
    let currentTimePercentage = 0;
    let keyframes = '';

    for (let currentSlide = 0; currentSlide < totalSlides - 1; currentSlide++) {
        const pauseEndPercentage = currentTimePercentage + pausePerSlide;
        const currentTranslatePercentage = -(currentSlide * 100) / totalSlides;

        keyframes += `
        ${currentTimePercentage.toFixed(2)}%, ${pauseEndPercentage.toFixed(2)}% {
          transform: translateY(${currentTranslatePercentage}%);
        }
      `;
        currentTimePercentage = pauseEndPercentage;

        const nextTranslatePercentage = -((currentSlide + 1) * 100) / totalSlides;

        // Если это последний слайд, то продолжаем анимацию
        if (currentSlide === totalSlides - 2) {
            keyframes += `
          ${(currentTimePercentage + transitionPerSlide).toFixed(2)}%, 100% {
            transform: translateY(${nextTranslatePercentage}%);
          }
        `;
        } else {
            keyframes += `
          ${(currentTimePercentage + transitionPerSlide).toFixed(2)}% {
            transform: translateY(${nextTranslatePercentage}%);
          }
        `;
            currentTimePercentage += transitionPerSlide;
        }
    }

    return `@keyframes ${animationName}-${totalSlides} { ${keyframes} }`;
}
